<script>
  /**
   * @type {string}
   */
  export let color = "#1C1C20";
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <path
    d="M10.55 15.7L16.75 9.50005L16.25 9.00005L10.55 14.7L7.70005 11.85L7.20005 12.35L10.55 15.7ZM12.0043 20.7C10.8015 20.7 9.67038 20.4718 8.61105 20.0153C7.55172 19.5588 6.6303 18.9392 5.8468 18.1565C5.06313 17.3739 4.4428 16.4536 3.9858 15.3958C3.52863 14.3378 3.30005 13.2073 3.30005 12.0043C3.30005 10.8015 3.5283 9.67038 3.9848 8.61105C4.4413 7.55172 5.06088 6.6303 5.84355 5.8468C6.62622 5.06313 7.54647 4.4428 8.6043 3.9858C9.6623 3.52863 10.7928 3.30005 11.9958 3.30005C13.1986 3.30005 14.3297 3.5283 15.389 3.9848C16.4484 4.4413 17.3698 5.06088 18.1533 5.84355C18.937 6.62622 19.5573 7.54647 20.0143 8.6043C20.4715 9.6623 20.7 10.7928 20.7 11.9958C20.7 13.1986 20.4718 14.3297 20.0153 15.389C19.5588 16.4484 18.9392 17.3698 18.1565 18.1533C17.3739 18.937 16.4536 19.5573 15.3958 20.0143C14.3378 20.4715 13.2073 20.7 12.0043 20.7Z"
    fill={color}
  />
</svg>
